import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.css"

export default class extends Controller {
    static targets = ["select"]

    connect() {
        this.initializeTomSelect();
    }

    initializeTomSelect() {
        this.tomselect = new TomSelect(this.selectTarget, {
            plugins: ['remove_button'],
            create: false,
            maxItems: null,
            multiple: true,
            placeholder: "Kompetenzen hinzufügen...",
            openOnFocus: true,
            preload: 'focus',
            closeAfterSelect: false,
            selectOnTab: true,
            maxOptions: 100,
            load: (query, callback) => {
                if (!query.length) return callback();
                
                // Verwende die Backend-Such-API
                const url = `/de/backend/search/?model=competencies&term=${encodeURIComponent(query)}`
                
                fetch(url)
                    .then(response => response.json())
                    .then(json => {
                        callback(json)
                    }).catch(() => {
                        callback()
                    })
            },
            render: {
                no_results: function(data, escape) {
                    return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '"</div>';
                },
                option: function(item, escape) {
                    return `<div class="option">
                        <span class="title text-sm">${escape(item.text)}</span>
                        ${item.subtext ? `<span class="subtext text-xs text-gray-500">${item.subtext}</span>` : ''}
                    </div>`
                },
                item: function(item, escape) {
                    return `<div class="item text-sm">${escape(item.text)}</div>`
                }
            }
        });
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy();
        }
    }
}
